const POST_LOGIN_NOTIFICATION_PROMPT_KEY = 'FP_POST_LOGIN_NOTIFICATION_PROMPT';

const getSessionStorage = (): Storage | null => {
  if (typeof window === 'undefined') return null;

  try {
    return window.sessionStorage;
  } catch {
    return null;
  }
};

export const schedulePostLoginNotificationPermissionPrompt = (): void => {
  getSessionStorage()?.setItem(POST_LOGIN_NOTIFICATION_PROMPT_KEY, 'true');
};

export const hasPostLoginNotificationPermissionPrompt = (): boolean =>
  getSessionStorage()?.getItem(POST_LOGIN_NOTIFICATION_PROMPT_KEY) === 'true';

export const clearPostLoginNotificationPermissionPrompt = (): void => {
  getSessionStorage()?.removeItem(POST_LOGIN_NOTIFICATION_PROMPT_KEY);
};
